import axios from 'axios'
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '../components/Box'
import Breadcrumb from '../components/Breadcrumb'
import ManageTable from '../components/ManageTable'
import { TableHeaderDataProps } from '../components/Table'
import { fetchSupplier } from '../fetchers/fetcher'
import { errorCallback } from '../helpers/errorCallback'
import { errorMessage } from '../helpers/errorMessage'
import useAlert from '../hooks/useAlert'
import useLogin from '../hooks/useLogin'
import {DeleteIcon, EditIcon} from '../icons/icon'
import { ISupplier } from '../types/types'

const breadCrumbItems = [
    { name: "Supplier Maintenance", active: true },
]

let defaultHeader: TableHeaderDataProps[] = [
    { key: "s_id", name: "ID", width: "4%", sort: "unsort" },
    { key: "date_time", name: "Date", width: "6%", sort: "unsort" },
    { key: "supplier", name: "Supplier", sort: "unsort" },
    { key: "type", name: "Type", width: "5%" },
    { key: "action", name: "Action", align: "center", width: "5%" },
]

const SupplierList = () => {
    let history = useNavigate()
    const {token, setToken} = useLogin()
    const [data, setData] = useState<any[]>([])
    const [loading, setLoading] = useState(true)
    const [reload, setReload] = useState(false)

    const {setAlert} = useAlert()

    const handleDelete = useCallback((_data: ISupplier) => {
        setAlert({
            show: true,
            message: "Delete " + _data.supplier + " ?",
            type: "question",
            cb: async () => {
                try {
                    let result = await axios.delete("/supplier/" + _data.s_id)

                    if(result.status !== 200) {
                        return setAlert({
                            show: true,
                            message: result.data.message,
                            type: "danger"
                        })
                    }

                    return setAlert({
                        show: true,
                        message: "Delete Supplier Successfully !!!",
                        type: "success",
                        cb: () => {
                            setData(v => v.filter(row => row.s_id !== _data.s_id))
                        }
                    })

                } catch (err: any) {
                    console.log(err.message)
                    setAlert({
                        show: true,
                        message: err.message,
                        type: "danger"
                    })
                }
            }
        })
    }, [setAlert])

    const fetchData = useCallback(async () => {
        setLoading(true)
        try {

            let _data = await fetchSupplier(token)

            setData(_data.map(row => ({ 
                ...row,
                action: <Box justifyContent='center' alignItems='center'>
                    <EditIcon iconcolor="blue" iconsize='h6' onClick={() => history("/supplier/" + row.s_id)} />
                    <DeleteIcon iconcolor="red" iconsize='h6' onClick={() => handleDelete(row)} />
                </Box>
            })))
            setLoading(false)
        } catch (err: any) {
            console.log(err.message)
            setLoading(false)
            setAlert({
                show: true,
                message: err.message,
                type: "danger",
                ok: errorMessage(err.message),
                cb: () => errorCallback(err.message, setReload, reload, setToken)
            })
        }

    }, [token, history, reload, setReload, setToken, setAlert, handleDelete])

    useEffect(() => {
        fetchData()
    }, [fetchData])

    return (
        <>
            <Breadcrumb items={breadCrumbItems} 
            button={[
                {
                    name: "New",
                    action: "/supplier/new",
                    color: "blue"
                }
            ]} 
            />
            <ManageTable 
            defaultHeader={defaultHeader}
            columnSetting="supplierList"
            data={data}
            filterKey={["supplier"]}
            loading={loading}
            />
        </>
    )
}

export default SupplierList